module.exports = __webpack_public_path__ + "img/picture.65571757.png";